// src/components/common/ErrorBoundary.jsx
import React from 'react';
// No useTranslation here as it might also fail if i18n isn't set up yet
// import { useTranslation } from 'react-i18next';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {

    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // const { t } = this.props; // If you pass t as a prop from a HOC
      const t = (key, fallback) => fallback || key; // Simple fallback

      return this.props.fallback || (
        <div className="p-8 text-center bg-red-50 min-h-screen flex flex-col justify-center items-center">
          <h2 className="text-2xl font-semibold text-red-700 mb-4">
            {t('errorBoundary.title', 'Oops! Something went wrong.')}
          </h2>
          <p className="text-red-600 mb-6">
            {t('errorBoundary.message', 'We encountered an unexpected issue. Please try refreshing the page.')}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-md transition-colors"
          >
            {t('errorBoundary.refresh', 'Refresh Page')}
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <div className="mt-8 p-4 bg-red-100 border border-red-300 rounded-md text-left max-w-2xl mx-auto overflow-auto">
              <h3 className="text-lg font-semibold text-red-800 mb-2">Error Details:</h3>
              <pre className="text-sm text-red-700 whitespace-pre-wrap">
                {this.state.error.toString()}
              </pre>
              {this.state.errorInfo && (
                <>
                  <h4 className="text-md font-semibold text-red-800 mt-3 mb-1">Component Stack:</h4>
                  <pre className="text-sm text-red-700 whitespace-pre-wrap">
                    {this.state.errorInfo.componentStack}
                  </pre>
                </>
              )}
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;